import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Divider,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import eligibleCheckIcon from "../../assets/images/eligible.gif";
// import notEligibleCheckIcon from "../../assets/images/not-eligible.gif";
import VoterRegistration from "./../../assets/svgIcons/_x31_9_Voter_Registration.svg";
import NoVoterRegistration from "./../../assets/svgIcons/not-eligible-check-icon.svg";
import ListDetails from "./../../assets/svgIcons/list-details.svg";
import FileText from "./../../assets/svgIcons/file-text.svg";
import FileCheck from "./../../assets/svgIcons/file-check.svg";
import CreditCard from "./../../assets/svgIcons/credit-card.svg";
import EligibilityCard, { StepData } from "../../components/ui/EligibilityCard";
import { PrimaryButton } from "../../components/ui/Button";
import { AppDispatch, RootState } from "../../services/redux/store";
import axiosInstance from "../../services/api/interceptor/interceptor";
import { decrypt, encrypt } from "../../utils/crypto";
import {
  authStatusSelector,
  setUserAuth,
  setUserLoanCategory,
  setUserBusinessType,
  setUserPermission,
  setUserProfileData,
} from "../../services/redux/slices/authSlice";
import {
  setActiveHorizontalIndex,
  setCompletedHorizontalIndex,
  setIsBypassLogin,
  setIsEligibilityCheckSubmitted,
  setIsEligible,
  setIsPreLogin,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import { setBreData } from "../../services/redux/slices/stepperDynamicFormSlice";
import chatServices from "../../services/api/service/chatService";
import { setChatStatusConfig } from "../../services/redux/slices/chatSlice";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import { getGAEligibilityStatements ,getCombinedApplicationSteps} from "../../components/ui/StepperDyanmicForm/helper";
import { fetchUserApplicationsFormData } from "../../services/api/service/userApplicationService";
import {
  setDisplayHorizontalSteps,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { setLeadSequenceId } from "../../services/redux/slices/stepperDynamicFormSlice";
// Props
interface Props {
  onNext: () => void;
  firstName: string;
  provisionalOffer: any;
}

// ✅ Step data for EligibilityCard
const steps: StepData[] = [
  {
    icon: ListDetails,
    title: "Applicant & Loan Details",
  },
  {
    icon: FileText,
    title: "Provisional Loan Offer Letter",
  },
  {
    icon: FileText,
    title: "Additional Details & Documents",
  },
  {
    icon: FileCheck,
    title: "Final Verification & Sanction",
  },
  {
    icon: CreditCard,
    title: "Loan Disbursement",
  },
];

// ✅ Main Component
const EligibilityConfirmation: React.FC<Props> = ({
  onNext,
  firstName,
  provisionalOffer,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const mobile = useSelector(
    (state: RootState) => state?.stepper?.formData?.phone_number
  );
  const [isContinueDisabled, setIsContinueDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const isAuthenticated = useSelector(authStatusSelector);
  const trackingId = useSelector(
    (state: RootState) => state?.stepper?.trackingId
  );
  const { isEligible } = useSelector((state: RootState) => state?.stepper);
  const breStatus = useSelector(
    (state: RootState) => state?.stepper?.breStatus
  );
  const userProfileData = useSelector((state: RootState) => state?.auth?.userProfile);

  const handleBreInvokApi = async () => {
    try {
      setIsLoading(true);
      const payload = {
        applicationId: trackingId,
        name: "getCustomerEligibility",
      };
      const res: any = await eligibilityCheckServices.fetchBreApi(payload);

      if (res?.status === 400) {
        setErrorMsg(
          "Uh-oh! We are experiencing some technical issues. Please try again later."
        );
        setIsContinueDisabled(true);
        setIsLoading(false);
        return;
      }

      if (res?.data?.data?.Scheme_Available != "Yes") {
        setIsContinueDisabled(true);
        dispatch(setIsEligible(false));
        setIsLoading(false);
        return;
      }
      dispatch(setBreData(res?.data?.data));
      dispatch(setIsEligible(res?.data?.data?.Scheme_Available == "Yes"));
      setIsLoading(false);
    } catch (e) {
      // dispatch(
      //   setStatusPopup({
      //     status: "info",
      //     message: "Something went wrong !",
      //   })
      // );
      setIsContinueDisabled(true);
      setIsLoading(false);
      return;
    }
  };

  useEffect(() => {
    if (isAuthenticated && breStatus == "FROM_APPLICATION") {
      handleBreInvokApi();
    }
    if (isAuthenticated && breStatus == "FROM_FORM") {
      dispatch(setBreData(provisionalOffer));
      setIsLoading(false);
    }
    if (!isAuthenticated && breStatus == "FROM_FORM") {
      setIsLoading(false);
    }
  }, [trackingId, isAuthenticated, breStatus]);

  const getChatFeatureStatus = async () => {
    try {
      const res = await chatServices.getChatFeatureStatus({
        applicationId: trackingId
      });

      const responseData = res.data?.data;
      if (responseData) {
        dispatch(setChatStatusConfig({
          chatAccess: responseData.chatAccess,
          viewAccess: responseData.viewAccess,
          loading: false
        }));
      }
    } catch (error) {
    }
  };

  const handleContinueClick = async () => {

    trackCustomerJourneyEvent(
      `${getGAEligibilityStatements(trackingId)}_ELIGIBILITYCONF_PAGE4`,
      decrypt(userProfileData?.id) ?? "",
      trackingId,
      {
        label: `${getGAEligibilityStatements(trackingId)}_ELIGIBILITYCONF_PAGE4`,
        category: `${getGAEligibilityStatements(trackingId)}_ELIGIBILITYCONF_PAGE4`,
        action: `${getGAEligibilityStatements(trackingId)}_ELIGIBILITYCONF_PAGE4`,
        page: "EligibiityCheck_Confirmation on Eligibility",
      }
    );

    if (isAuthenticated) {
      dispatch(setActiveHorizontalIndex(1));
      await getChatFeatureStatus();
      // dispatch(dispatch(setCompletedHorizontalIndex(0)));
      // dispatch(setIsEligibilityCheckSubmitted(true));
      return;
    } else {
      try {
        const encryptedKey = encrypt(mobile);
        const resp: any = await axiosInstance.post(
          "api/v1/user-lead/guest-login",
          {
            key: encryptedKey,
            role: "applicant"
          }
        );
        if (resp.data?.status === "success") {
          //await getChatFeatureStatus();
          const data: any = JSON.parse(decrypt(resp?.data?.data));
          dispatch(setUserProfileData(data?.user));
          dispatch(setUserPermission(data?.permission));
          dispatch(
            setUserBusinessType(
              data?.businessType.length > 0 ? data?.businessType?.[0] : {}
            )
          );
          dispatch(setUserLoanCategory(data?.result));
          dispatch(setUserAuth(data?.token));
          dispatch(setIsBypassLogin(true));
          dispatch(setIsPreLogin(true));
          dispatch(setIsEligibilityCheckSubmitted(true));
           const token: any = process.env.REACT_APP_FETCH_TOKEN;
          const res: any = await fetchUserApplicationsFormData(
            token,
            trackingId
          );
          const apps = res.data?.applications || [];
          let fetchUserApplicationRes = apps[0];
          let finalSteps = getCombinedApplicationSteps(apps[0]);
          dispatch(setDisplayHorizontalSteps(finalSteps));
          dispatch(setLeadSequenceId(fetchUserApplicationRes?.leadId));
          dispatch(setActiveHorizontalIndex(1));
        } else {
          console.error(resp.data?.message || "Bypass login failed");
        }
      } catch (error: any) {
        console.error(error?.response?.data?.message || "Bypass login failed");
      }
    }
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      className="eligibility-container"
      sx={{
        px: { xs: 0, sm: 3, md: 4 },
        py: { xs: 2, sm: 3 },
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "text.secondary",
              maxWidth: 600,
              fontSize: { xs: "14px", sm: "18px" },
            }}
          >
            Loading...
          </Typography>
        </Box>
      ) : errorMsg ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Box
            mb={{ xs: 1, sm: 2 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={NoVoterRegistration}
              alt="eligible check icon"
              width={isMobile ? 80 : 117}
              height={isMobile ? 64 : 94}
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </Box>

          <Typography
            sx={{
              color: "text.secondary",
              maxWidth: 600,
              fontSize: { xs: "14px", sm: "18px" },
            }}
          >
            {errorMsg}
          </Typography>
        </Box>
      ) : (
        <>
          {/* ✅ Header Icon */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            mb={{ xs: 2, sm: 3 }}
          >
            <Box
              my={{ xs: 1, sm: 2 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                // src={isEligible ? eligibleCheckIcon : notEligibleCheckIcon}
                src={isEligible ? VoterRegistration : NoVoterRegistration}
                alt="eligible check icon"
                width={isMobile ? 80 : 117}
                height={isMobile ? 64 : 94}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  // width: "100%",
                  // height: 200,
                  // objectFit: "contain",
                  // display: "inline-block",
                }}
              />
            </Box>

            {/* ✅ Heading */}
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 700,
                color: "#008688",
                fontSize: { xs: "20px", sm: "22px", md: "24px" },
                lineHeight: "120%",
                letterSpacing: "-0.5px",
                textAlign: "center",
                px: { xs: 1, sm: 0 },
                mt: { xs: 1, sm: 2 },
              }}
            >
              {isEligible && <>Congratulations, </>}

              {isEligible ? (
                <Box component="span" fontWeight={700} color="#000">
                  {/* "You're eligible,{" "} */}
                  {firstName}!
                </Box>
              ) : (
                <>
                  <Box component="span" fontWeight={700} color="#000">
                    {/* You’re not eligible, {firstName}! */}
                    Thanks for applying, {firstName}! While we don't have an instant match, our team is on it. Our experts will reach out soon to help you.
                  </Box>
                </>
              )}
            </Typography>

            {/* ✅ Paragraph Text */}
            <Typography
              variant="body2"
              className="eligibility-message-text"
              sx={{
                mb: { xs: 1, sm: 1 },
                maxWidth: 600,
                fontSize: { xs: "14px", sm: "15px !important" },
                color: '#7f7f7f',
                lineHeight: { xs: "1.4", sm: "1.5" },
                px: { xs: 1, sm: 0 },
              }}
            >
              {isEligible ? (
                <>
                  {/* We're excited to let you know that based on the details provided,
              we have a Student Loan Product perfectly suited for your
              international education plans! */}
                  You are eligible for a student loan! Based on the information
                  you've provided, we've crafted a financing solution to power
                  your academic journey. Take the next step toward your
                  educational dreams — we’ll be with you every step of the way.
                </>
              ) : (
                <>
                  {/* Unfortunately, based on the details you provided, we don't have a
              Student Loan Product that's a good fit for your international
              education plans right now. */}
                  {/* Oops! It seems we don't have the right financing solution for
                  you at the moment that matches your profile. Please connect
                  with your sales manager for further information. */}
                  {/* Thank you for completing your application. While we don't have an instant match for your requirements right now, we are committed to helping you. Your Sales Manager will reach out shortly to guide you through the next steps of your education loan journey. */}

                  {/* Thanks for applying, {firstName}! While we don't have an instant match, our team is on it. Our experts will reach out soon to help you. */}
                </>
              )}
            </Typography>

            {/* ✅ CTA Button */}
            {isEligible && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  my: { xs: 2 },
                }}
              >
                <Grid
                  container
                  spacing={2}
                  justifyContent={{ xs: "center", sm: "flex-start" }}
                >
                  <Grid item xs={12}>
                    <PrimaryButton
                      type="submit"
                      fullWidth
                      onClick={handleContinueClick}
                      disabled={isContinueDisabled}
                      sx={{
                        backgroundColor: "#ffd700 !important", // Bright yellow
                        color: "#000000 !important", // Black text
                        fontSize: { xs: "14px", sm: "16px" },
                        fontWeight: "700 !important",
                        fontFamily: "Jost, sans-serif !important",
                        borderRadius: "8px !important",
                        padding: "12px 32px !important",
                        textTransform: "none !important",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1) !important",
                        "&:hover": {
                          backgroundColor: "#ffed4e !important",
                          boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15) !important",
                        },
                      }}
                    >
                      Continue for Provisional Offer
                    </PrimaryButton>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* <Typography
              variant="body2"
              className="eligibility-message-text"
              sx={{
                color: "text.secondary",
                maxWidth: 600,
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: { xs: "1.4", sm: "1.5" },
                px: { xs: 1, sm: 0 },
              }}
            >
              {isEligible ? (
                <>
                  This means we can help you finance your academic journey abroad
                  and take a significant step towards achieving your goals.
                </>
              ) : (
                <>
                  However, we're always working to expand our offerings. We will be
                  sure to contact you if a product becomes available that aligns
                  with your requirements.
                </>
              )}
            </Typography> */}
          </Box>

          {isEligible && (
            <>
              {/* ✅ Divider */}
              <Divider sx={{ my: { xs: 2, sm: 3 } }} />

              {/* ✅ Section Header */}
              <Typography
                className="eligibility-sub-heading"
                mt={{ xs: 1, sm: 2 }}
                mb={{ xs: 1.5, sm: 2 }}
                fontWeight={600}
                fontSize={{ xs: "16px", sm: "18px" }}
                color="#333"
                sx={{
                  px: { xs: 1, sm: 0 },
                }}
              >
                Next Steps
              </Typography>

              {/* ✅ Steps using EligibilityCard */}
              <Box
                sx={{
                  mb: { xs: 2, sm: 3 },
                  px: { xs: 0, sm: 0 },
                  width: "100%",
                }}
              >
                <EligibilityCard steps={steps} />
              </Box>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default EligibilityConfirmation;